import { gql } from '@apollo/client';
import { ID_NAME_FIELDS, PAGINATION_FIELDS } from 'graphql/common/fragments';

export const COMPANY_PAGINATION_DATA_FRAGMENT = gql`
  fragment companyPaginationData on CompanySearchResponse {
    ${PAGINATION_FIELDS}
  }
`;

export const COMPANY_BASIC_RESULTS_FRAGMENT = gql`
  fragment companyBasicResults on Company {
    id
    name
    headquarters
    domain
    website
    logoUrl
    industry {
      ${ID_NAME_FIELDS}
    }
    mergedAt
    mergedCompanyId
    mergeCompanyEventId
    mergedCompany {
      id
      name
      headquarters
      industry {
        ${ID_NAME_FIELDS}
      }
    }
  }
`;
